import { Tooltip } from '@mui/material';
import { sportsbookColourMapping } from '../pages/evscreen/EvScreenTable/SportsbookColourMapping';
import external_link_icon from '../assets/images/external_link_icon.svg';
import onexbetLogo from '../assets/images/sportsbook_logos/onexbet.webp';
import eight88SportLogo from '../assets/images/sportsbook_logos/888sport.webp';
import action247Logo from '../assets/images/sportsbook_logos/action247.webp';
import bcGameLogo from '../assets/images/sportsbook_logos/bc_game.webp';
import bet99Logo from '../assets/images/sportsbook_logos/bet99.webp';
import ballyBetLogo from '../assets/images/sportsbook_logos/BallyBet.webp';
import betAnySportsLogo from '../assets/images/sportsbook_logos/betanysports.jpg';
import betRightLogo from '../assets/images/sportsbook_logos/betright.webp';
import betDEXLogo from '../assets/images/sportsbook_logos/betdex.webp';
import betDSILogo from '../assets/images/sportsbook_logos/betdsi.webp';
import betDSILogoSBLogo from '../assets/images/sportsbook_logos/betdsi_superbook.webp';
import betMGMLogo from '../assets/images/sportsbook_logos/BetMGM.png';
import betOnlineLogo from '../assets/images/sportsbook_logos/BetOnline.png';
import betOpenlyLogo from '../assets/images/sportsbook_logos/betopenly.webp';
import betOpenlyDFSLogo from '../assets/images/sportsbook_logos/betopenly.webp';
import betRiversLogo from '../assets/images/sportsbook_logos/betrivers-new.png';
import betRiversNYLogo from '../assets/images/sportsbook_logos/BetRivers.png';
import betUSLogo from '../assets/images/sportsbook_logos/BetUS.png';
import betVictor from '../assets/images/sportsbook_logos/betvictor.webp';
import betano from '../assets/images/sportsbook_logos/betano.webp';
import betcris from '../assets/images/sportsbook_logos/betcris.webp';
import betfair from '../assets/images/sportsbook_logos/betfair.webp';
import betfairExchangeLogo from '../assets/images/sportsbook_logos/betfairexchange.webp';
import betfairExchangeLayLogo from '../assets/images/sportsbook_logos/betfairexchange.webp';
import betfredLogo from '../assets/images/sportsbook_logos/betfred.webp';
import betnacionalLogo from '../assets/images/sportsbook_logos/betnacional.webp';
import betplayLogo from '../assets/images/sportsbook_logos/betplay.webp';
import betrLogo from '../assets/images/sportsbook_logos/betr_sb.webp';
import betrPicksLogo from '../assets/images/sportsbook_logos/betr_picks.webp';
import betrPicksAllLogo from '../assets/images/sportsbook_logos/betr_picks.webp';
import betrPicksBoostedLogo from '../assets/images/sportsbook_logos/betr_picks.webp';
import betsafeLogo from '../assets/images/sportsbook_logos/betsafe.webp';
import betssonLogo from '../assets/images/sportsbook_logos/betsson.webp';
import betwayLogo from '../assets/images/sportsbook_logos/betway.webp';
import bodogLogo from '../assets/images/sportsbook_logos/bodog.webp';
import bookMakerLogo from '../assets/images/sportsbook_logos/bookmaker.webp';
import boomFantasyLogo from '../assets/images/sportsbook_logos/boomfantasy.webp';
import borgataLogo from '../assets/images/sportsbook_logos/borgata.webp';
import bovadaLogo from '../assets/images/sportsbook_logos/Bovada.png';
import caesarsLogo from '../assets/images/sportsbook_logos/Caesars.png';
import caesarsLouisianaLogo from '../assets/images/sportsbook_logos/Caesars.png';
import caesarsMaineLogo from '../assets/images/sportsbook_logos/Caesars.png';
import caesarsNewYorkLogo from '../assets/images/sportsbook_logos/Caesars.png';
import caesarsOntarioLogo from '../assets/images/sportsbook_logos/Caesars.png';
import caesarsPennsylvaniaLogo from '../assets/images/sportsbook_logos/Caesars.png';
import caesarsTennesseeLogo from '../assets/images/sportsbook_logos/Caesars.png';
import casumoLogo from '../assets/images/sportsbook_logos/casumo.webp';
import circaSportsLogo from '../assets/images/sportsbook_logos/circasports.webp';
import circaVegasLogo from '../assets/images/sportsbook_logos/circavegas.webp';
import codereLogo from '../assets/images/sportsbook_logos/codere.webp';
import coolbetLogo from '../assets/images/sportsbook_logos/coolbet.webp';
import crabSportsLogo from '../assets/images/sportsbook_logos/crab_sports.webp';
import dabbleLogo from '../assets/images/sportsbook_logos/dabble.webp';
import dabbleAustraliaLogo from '../assets/images/sportsbook_logos/dabble.webp';
import dafabetLogo from '../assets/images/sportsbook_logos/dafabet.webp';
import desertDiamondLogo from '../assets/images/sportsbook_logos/desertdiamond.webp';
import draftkingsLogo from '../assets/images/sportsbook_logos/DraftKings.png';
import draftKingsPick6Logo from '../assets/images/sportsbook_logos/DraftKings.png';
import espnBetLogo from '../assets/images/sportsbook_logos/espnbet.webp';
import eliteBetLogo from '../assets/images/sportsbook_logos/espnbet.webp';
import fanDuelLogo from '../assets/images/sportsbook_logos/Fanduel_Shield_2022.png';
import fanDuelOntarioLogo from '../assets/images/sportsbook_logos/Fanduel_Shield_2022.png';
import fanaticsLogo from '../assets/images/sportsbook_logos/Fanatics-Sportsbook-logo.webp';
import fireKeepersLogo from '../assets/images/sportsbook_logos/firekeepers.webp';
import fliffLogo from '../assets/images/sportsbook_logos/fliff.webp';
import fourWindsLogo from '../assets/images/sportsbook_logos/fourwinds.webp';
import ggBetLogo from '../assets/images/sportsbook_logos/GGBet.webp';
import galerabetLogo from '../assets/images/sportsbook_logos/galera.webp';
import goldenNuggetLogo from '../assets/images/sportsbook_logos/goldennugget.webp';
import hardRockLogo from '../assets/images/sportsbook_logos/hardrock.jpg';
import hotStreakLogo from '../assets/images/sportsbook_logos/hotstreak.webp';
import juiceBetLogo from '../assets/images/sportsbook_logos/juicebet.webp';
import kuttLogo from '../assets/images/sportsbook_logos/kutt.webp';
import ladbrokesLogo from '../assets/images/sportsbook_logos/ladbrokes.webp';
import ladbrokesAustraliaLogo from '../assets/images/sportsbook_logos/ladbrokes.webp';
import leoVegasLogo from '../assets/images/sportsbook_logos/leovegas.webp';
import miseOJeuLogo from '../assets/images/sportsbook_logos/miseojeu.webp';
import myBookieLogo from '../assets/images/sportsbook_logos/mybookie.webp';
import nedsLogo from '../assets/images/sportsbook_logos/neds.webp';
import northStarBetsLogo from '../assets/images/sportsbook_logos/northstarbets.webp';
import novigLogo from '../assets/images/sportsbook_logos/Novig.webp';
import parlayPlayLogo from '../assets/images/sportsbook_logos/parlayplay.webp';
import picklebetLogo from '../assets/images/sportsbook_logos/picklebet.webp';
import pinnacleLogo from '../assets/images/sportsbook_logos/pinnacle.webp';
import { getSportsbookDisplayName } from '../utils/sportsbookAliases';
import pinnyLogo from '../assets/images/sportsbook_logos/pinnacle.webp';
import playAlbertaLogo from '../assets/images/sportsbook_logos/PlayAlberta.webp';
import playEagleLogo from '../assets/images/sportsbook_logos/playeagle.webp';
import playNowLogo from '../assets/images/sportsbook_logos/playnow.webp';
import pointsBetAustraliaLogo from '../assets/images/sportsbook_logos/Pointsbet.png';
import pointsBetOntarioLogo from '../assets/images/sportsbook_logos/Pointsbet.png';
import prizePicksLogo from '../assets/images/sportsbook_logos/prizepicks.webp';
import prizePicks5or6PickLogo from '../assets/images/sportsbook_logos/prizepicks.webp';
import prizePicksDemonsAndGoblinsLogo from '../assets/images/sportsbook_logos/prizepicks.webp';
import prolineLogo from '../assets/images/sportsbook_logos/proline.webp';
import prophetXLogo from '../assets/images/sportsbook_logos/prophetx.webp';
import rebetLogo from '../assets/images/sportsbook_logos/rebet.webp';
import rebetPropsCityLogo from '../assets/images/sportsbook_logos/rebet_props_city.webp';
import resortsWorldBetLogo from '../assets/images/sportsbook_logos/resortsworldbet.webp';
import sboBetLogo from '../assets/images/sportsbook_logos/SBobet_logo.png';
import stnSportsLogo from '../assets/images/sportsbook_logos/stnsports.webp';
import sxBetLogo from '../assets/images/sportsbook_logos/sxbet.webp';
import sleeperLogo from '../assets/images/sportsbook_logos/sleeper.webp';
import sportingbetLogo from '../assets/images/sportsbook_logos/sportingbet.webp';
import sportsInteractionLogo from '../assets/images/sportsbook_logos/sportsinteraction.webp';
import sportsbetLogo from '../assets/images/sportsbook_logos/sportsbet.webp';
import sportsbettingAgLogo from '../assets/images/sportsbook_logos/sportsbettingag.webp';
import sporttradeLogo from '../assets/images/sportsbook_logos/Sporttrade-icon-on-black.png';
import sporttradeColoradoLogo from '../assets/images/sportsbook_logos/Sporttrade-icon-on-black.png';
import sportzinoLogo from '../assets/images/sportsbook_logos/sportzino.webp';
import stakeLogo from '../assets/images/sportsbook_logos/stake.webp';
import sugarHouseLogo from '../assets/images/sportsbook_logos/sugarhouse.webp';
import superbetLogo from '../assets/images/sportsbook_logos/superbet.png';
import tabLogo from '../assets/images/sportsbook_logos/tab.jpg';
import tabNewZealandLogo from '../assets/images/sportsbook_logos/tab.jpg';
import tabTouchLogo from '../assets/images/sportsbook_logos/tabtouch.png';
import thrillzzLogo from '../assets/images/sportsbook_logos/thrillz.webp';
import tonyBetLogo from '../assets/images/sportsbook_logos/tonybet.webp';
import topSportLogo from '../assets/images/sportsbook_logos/topsport.png';
import twinSpiresLogo from '../assets/images/sportsbook_logos/twinspires.webp';
import underdogFantasyLogo from '../assets/images/sportsbook_logos/underdogfantasy.webp';
import underdogFantasy3or5PickLogo from '../assets/images/sportsbook_logos/underdogfantasy.webp';
import underdogFantasy6PickLogo from '../assets/images/sportsbook_logos/underdogfantasy.webp';
import underdogSportsbookLogo from '../assets/images/sportsbook_logos/underdog_sportsbook.jpg';
import unibetLogo from '../assets/images/sportsbook_logos/unibet_fullname.png';
import unibetAustraliaLogo from '../assets/images/sportsbook_logos/unibet_fullname.png';
import unibetUnitedKingdomLogo from '../assets/images/sportsbook_logos/unibet_fullname.png';
import vividPicksLogo from '../assets/images/sportsbook_logos/vividpicks.png';
import vividPicks4PickLogo from '../assets/images/sportsbook_logos/vividpicks.png';
import williamHillLogo from '../assets/images/sportsbook_logos/williamhill.jpg';
import windCreekLogo from '../assets/images/sportsbook_logos/windcreek.png';
import xBetLogo from '../assets/images/sportsbook_logos/xbet.jpg';
import bet365Logo from '../assets/images/sportsbook_logos/bet365.webp';
import betJACKLogo from '../assets/images/sportsbook_logos/betjack.png';
import betPARXLogo from '../assets/images/sportsbook_logos/betparx.webp';
import betrAustraliaLogo from '../assets/images/sportsbook_logos/betr_australia.webp';
import betwhaleLogo from '../assets/images/sportsbook_logos/betwhale.webp';
import bwinLogo from '../assets/images/sportsbook_logos/bwin.webp';
import partypokerLogo from '../assets/images/sportsbook_logos/partypoker.webp';
import theScoreLogo from '../assets/images/sportsbook_logos/thescore.webp';
import wagerwizlogo from '../assets/wagerwizlogomarch.png';
import betlylogo from '../assets/images/sportsbook_logos/betlylogo.png'
import kambilogo from '../assets/images/sportsbook_logos/kambilogo.webp'
import superbooklogo from '../assets/images/sportsbook_logos/superbooklogo.png'
import prophetxlogo from '../assets/images/sportsbook_logos/prophetx.webp'
import tipicologo from '../assets/images/sportsbook_logos/tipicologo.jpeg'

const sportsbookLogoTable = {
	'1XBet': onexbetLogo,
	'888sport': eight88SportLogo,
	'Action 24/7': action247Logo,
	'BC.GAME': bcGameLogo,
	BET99: bet99Logo,
	'Bally Bet': ballyBetLogo,
	'Bet Right': betRightLogo,
	BetAnySports: betAnySportsLogo,
	BetDEX: betDEXLogo,
	BetDSI: betDSILogo,
	'BetDSI (Superbook)': betDSILogoSBLogo,
	BetMGM: betMGMLogo,
	BetOnline: betOnlineLogo,
	'Props Builder': betOnlineLogo,
	BetOpenly: betOpenlyLogo,
	'BetOpenly (Instant DFS)': betOpenlyDFSLogo,
	BetRivers: betRiversLogo,
	'BetRivers (New York)': betRiversNYLogo,
	BetUS: betUSLogo,
	'Betway (Alaska)': fanDuelLogo,
	BetVictor: betVictor,
	Betano: betano,
	Betcris: betcris,
	Betfair: betfair,
	'Betfair Exchange': betfairExchangeLogo,
	'Betfair Exchange (Lay)': betfairExchangeLayLogo,
	Betfred: betfredLogo,
	Betnacional: betnacionalLogo,
	Betplay: betplayLogo,
	Betr: betrLogo,
	'Betr Picks': betrPicksLogo,
	'Betr Picks (All)': betrPicksAllLogo,
	'Betr Picks (BOOSTED)': betrPicksBoostedLogo,
	Betsafe: betsafeLogo,
	Betsson: betssonLogo,
	Betway: betwayLogo,
	Bodog: bodogLogo,
	BookMaker: bookMakerLogo,
	'Boom Fantasy (5 Pick Insured)': boomFantasyLogo,
	Borgata: borgataLogo,
	Bovada: bovadaLogo,
	Caesars: caesarsLogo,
	'Caesars (Louisiana)': caesarsLouisianaLogo,
	'Caesars (Maine)': caesarsMaineLogo,
	'Caesars (New York)': caesarsNewYorkLogo,
	'Caesars (Ontario)': caesarsOntarioLogo,
	'Caesars (Pennsylvania)': caesarsPennsylvaniaLogo,
	'Caesars (Tennessee)': caesarsTennesseeLogo,
	Casumo: casumoLogo,
	'Circa Sports': circaSportsLogo,
	'Circa Vegas': circaVegasLogo,
	Codere: codereLogo,
	Coolbet: coolbetLogo,
	'Crab Sports': crabSportsLogo,
	'Dabble (3 or 5 Pick)': dabbleLogo,
	'Dabble (Australia)': dabbleAustraliaLogo,
	Dafabet: dafabetLogo,
	'Desert Diamond': desertDiamondLogo,
	DraftKings: draftkingsLogo,
	'DraftKings (Pick 6)': draftKingsPick6Logo,
	'ESPN BET': espnBetLogo,
	'Elite Bet': eliteBetLogo,
	FanDuel: fanDuelLogo,
	'FanDuel (Ontario)': fanDuelOntarioLogo,
	Fanatics: fanaticsLogo,
	FireKeepers: fireKeepersLogo,
	Fliff: fliffLogo,
	'Four Winds': fourWindsLogo,
	GGBet: ggBetLogo,
	'Galera.bet': galerabetLogo,
	'Golden Nugget': goldenNuggetLogo,
	'Hard Rock': hardRockLogo,
	HotStreak: hotStreakLogo,
	JuiceBet: juiceBetLogo,
	Kutt: kuttLogo,
	Ladbrokes: ladbrokesLogo,
	'Ladbrokes (Australia)': ladbrokesAustraliaLogo,
	LeoVegas: leoVegasLogo,
	'Mise-o-jeu': miseOJeuLogo,
	MyBookie: myBookieLogo,
	Neds: nedsLogo,
	'NorthStar Bets': northStarBetsLogo,
	Novig: novigLogo,
	ParlayPlay: parlayPlayLogo,
	Picklebet: picklebetLogo,
	Pinnacle: pinnacleLogo,
	Pinny: pinnyLogo,
	'Play Alberta': playAlbertaLogo,
	'Play Eagle': playEagleLogo,
	PlayNow: playNowLogo,
	'PointsBet (Australia)': pointsBetAustraliaLogo,
	'PointsBet (Ontario)': pointsBetOntarioLogo,
	'PointsBet': pointsBetOntarioLogo,
	'Betly': betlylogo,
	'Dabble': dabbleLogo,
	PrizePicks: prizePicksLogo,
	'PrizePicks (5 or 6 Pick Flex)': prizePicks5or6PickLogo,
	'PrizePicks (Demons and Goblins)': prizePicksDemonsAndGoblinsLogo,
	Proline: prolineLogo,
	'Prophet X': prophetXLogo,
	Rebet: rebetLogo,
	'Rebet Props City': rebetPropsCityLogo,
	'Resorts World Bet': resortsWorldBetLogo,
	SBOBET: sboBetLogo,
	'STN Sports': stnSportsLogo,
	'SX Bet': sxBetLogo,
	Sleeper: sleeperLogo,
	Sportingbet: sportingbetLogo,
	'Sports Interaction': sportsInteractionLogo,
	Sportsbet: sportsbetLogo,
	'Sportsbetting.ag': sportsbettingAgLogo,
	Sporttrade: sporttradeLogo,
	'Sporttrade (Colorado)': sporttradeColoradoLogo,
	Sportzino: sportzinoLogo,
	'Sportzino': sportzinoLogo,
	Stake: stakeLogo,
	SugarHouse: sugarHouseLogo,
	Superbet: superbetLogo,
	TAB: tabLogo,
	'TAB (New Zealand)': tabNewZealandLogo,
	TABtouch: tabTouchLogo,
	Thrillzz: thrillzzLogo,
	TonyBet: tonyBetLogo,
	TopSport: topSportLogo,
	TwinSpires: twinSpiresLogo,
	'Underdog Fantasy': underdogFantasyLogo,
	'Underdog Fantasy (3 or 5 Pick)': underdogFantasy3or5PickLogo,
	'Underdog Fantasy (6 Pick)': underdogFantasy6PickLogo,
	'Underdog Sportsbook': underdogSportsbookLogo,
	Unibet: unibetLogo,
	'Unibet (Australia)': unibetAustraliaLogo,
	'Unibet (United Kingdom)': unibetUnitedKingdomLogo,
	'Vivid Picks': vividPicksLogo,
	'Vivid Picks (4 Pick)': vividPicks4PickLogo,
	'William Hill': williamHillLogo,
	'Wind Creek': windCreekLogo,
	'Kambi': kambilogo,
	'SuperBook': superbooklogo,
	'ProphetX': prophetxlogo,
	'Tipico': tipicologo,
	XBet: xBetLogo,
	bet365: bet365Logo,
	betJACK: betJACKLogo,
	betPARX: betPARXLogo,
	'Sportzino': sportzinoLogo,
	'betr (Australia)': betrAustraliaLogo,
	betwhale: betwhaleLogo,
	bwin: bwinLogo,
	partypoker: partypokerLogo,
	theScore: theScoreLogo,
	WagerWiz1: wagerwizlogo,
	WagerWiz2: wagerwizlogo,
	WagerWiz: wagerwizlogo,
};

export const LogoGenerator = (props) => {
	const { selected, isMobile, smallLogos, largeSize, hasBetLink, isHovered, customSize } = props;
	let sportsbookName = props.sportsbook;
	if (sportsbookName === 'ww_props' || sportsbookName === 'WagerWiz Props') {
		sportsbookName = 'WagerWiz1';
	} else if (sportsbookName === 'ww_mains' || sportsbookName === 'WagerWiz Mains') {
		sportsbookName = 'WagerWiz2';
	} else {
		sportsbookName = getSportsbookDisplayName(sportsbookName);
	}

	// Determine logo size - larger for desktop when largeSize is true
	const logoWidth = customSize ? customSize : (smallLogos ? 25 : (largeSize && !isMobile ? 60 : (isMobile ? 30 : 50)));
	const logoHeight = logoWidth;

	if (!sportsbookLogoTable[sportsbookName]) {
		return <div style={{ color: 'white' }}>{sportsbookName}</div>;
	} else {
		return (
			<div 
				className="logo-generator" 
				style={{ 
					width: `${logoWidth}px`, 
					height: `${logoHeight}px`,
					backgroundColor: selected ? '#363844' : '',
					position: 'relative',
					transition: 'all 0.3s ease',
					transform: isHovered ? 'scale(1.05)' : 'scale(1)',
					overflow: 'hidden',
				}}
			>
				<Tooltip title={getSportsbookDisplayName(props.sportsbook)}>
					<div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden' }}>
						<img
							width={logoWidth}
							height={logoHeight}
							style={{
								borderRadius: '10px',
								backgroundColor: selected ? '#363844' : '',
								marginLeft: isMobile ? 10 : 0,
								opacity: isMobile ? 0.75 : 1,
								transition: 'all 0.3s ease',
								boxShadow: hasBetLink 
									? '0 0 8px rgba(59, 130, 246, 0.3), 0 0 15px rgba(59, 130, 246, 0.2)' 
									: 'none',
								cursor: hasBetLink && !isMobile ? 'pointer' : 'default',
								border: 'none',
							}}
							src={sportsbookLogoTable[sportsbookName]}
							alt="sportsbook logo"
						/>
						{/* Visual indicator for bet link existence - subtle glow effect */}
						{hasBetLink && !isMobile && (
							<div
								style={{
									position: 'absolute',
									top: 0,
									left: 0,
									right: 0,
									bottom: 0,
									borderRadius: '10px',
									background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(147, 51, 234, 0.1) 100%)',
									pointerEvents: 'none',
								}}
							/>
						)}
					</div>
				</Tooltip>
				<style>{`
				`}</style>
			</div>
		);
	}
};
